/* eslint-disable react/jsx-max-props-per-line */

import PropTypes from 'prop-types';
import React, { Component, Suspense } from 'react';
import AppLoading from '../Loading/AppLoading';
import { BrowserRouter, Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { ROUTES } from 'config/constants';
import { AuthedRoute, UnauthedRoute } from './components/RouteWrappers';
import { connect } from 'react-redux';
import {
    LoginContainer,
    PageNotFoundContainer,
    RecoverPasswordContainer,
    SetNewPasswordContainer,
    DashboardScreenContainer,
    ProductScreenContainer,
    ProfileScreenContainer,
    ProductDetailContainer,
    ProductDetailEditContainer,
    ProductVariationEditContainer,
    ProductVariationDetailContainer,
    TrainingVideosContainer,
    TrainingVideoDetailsContainer,
    UsersContainer,
    EditorContainer,
    SubCategoryContainer,
    HomeContainer,
    ProductConfigurationContainer,
    PublicProductContainer,
    SelectedRoomContainer,
    CategoryDetailsContainer,
    SearchContainer,
    TagSearchContainer,
    PublicVariationContainer,
    NotificationsContainer
} from './config/routes';

class AppRouter extends Component {
    static propTypes = {
        isAuthed: PropTypes.bool.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired
        }).isRequired
    }

    shouldComponentUpdate(nextProps) {
        const { isAuthed, location: { pathname } } = this.props;

        if (isAuthed !== nextProps.isAuthed || pathname !== nextProps.location.pathname) {
            return true;
        }

        return false;
    }

    render() {
        const { isAuthed, history } = this.props;

        return (
            <Suspense fallback={<AppLoading />}>
                {/* <BrowserRouter basename={APP_ROUTER_BASENAME}> */}
                <BrowserRouter>
                    <Switch>
                        <UnauthedRoute path={ROUTES.LOGIN} exact={true} component={LoginContainer} isAuthed={isAuthed} history={history} />
                        <Redirect from={ROUTES.ADMINPANEL} to={ROUTES.LOGIN} exact={true} />
                        <UnauthedRoute path={ROUTES.RECOVER_PASSWORD} exact={true} component={RecoverPasswordContainer} isAuthed={isAuthed} history={history} />
                        <UnauthedRoute path={ROUTES.SET_NEW_PASSWORD} exact={true} component={SetNewPasswordContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.DASHBOARD} exact={true} component={DashboardScreenContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.PROFILE} exact={true} component={ProfileScreenContainer} isAuthed={isAuthed} history={history} />

                        <AuthedRoute path={ROUTES.PRODUCT} exact={true} component={ProductScreenContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.PRODUCT_DETAIL()} exact={true} component={ProductDetailContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.PRODUCT_NEW} exact={true} component={ProductDetailEditContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.PRODUCT_EDIT()} exact={true} component={ProductDetailEditContainer} isAuthed={isAuthed} history={history} />

                        <AuthedRoute path={ROUTES.PRODUCT_VARIANT_DETAIL()} exact={true} component={ProductVariationDetailContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.PRODUCT_VARIANT_NEW()} exact={true} component={ProductVariationEditContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.PRODUCT_VARIANT_EDIT()} exact={true} component={ProductVariationEditContainer} isAuthed={isAuthed} history={history} />

                        <AuthedRoute path={ROUTES.TRAINING_VIDEOS} exact={true} component={TrainingVideosContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.TRAINING_VIDEO_DETAILS} exact={true} component={TrainingVideoDetailsContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.USERS} exact={true} component={UsersContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.EDITOR} exact={true} component={EditorContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.NOTIFICATIONS} exact={true} component={NotificationsContainer} isAuthed={isAuthed} history={history} />
                        <AuthedRoute path={ROUTES.SUBCATEGORY()} exact={true} component={SubCategoryContainer} isAuthed={isAuthed} history={history} />

                        <Route path={ROUTES.HOME} exact={true} component={HomeContainer} />
                        <Route path={ROUTES.SELECTED_ROOM()} exact={true} component={SelectedRoomContainer} />
                        <Route path={ROUTES.CATEGORY_DETAILS()} exact={true} component={CategoryDetailsContainer} />
                        <Route path={ROUTES.SEARCH()} exact={false} component={SearchContainer} />
                        <Route path={ROUTES.TAG()} exact={false} component={TagSearchContainer} />
                        <Route path={ROUTES.CONFIGURATION()} exact={true} component={ProductConfigurationContainer} />
                        <Route path={ROUTES.PUBLICPRODUCT()} exact={true} component={PublicProductContainer} />
                        <Route path={ROUTES.VARIATION()} exact={true} component={PublicVariationContainer} />
                        <Route path={ROUTES.NOTFOUND} component={PageNotFoundContainer} exact={true} />
                        <Redirect from='*' to={ROUTES.HOME} />
                    </Switch>
                </BrowserRouter>
            </Suspense >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthed: state.auth.isAuthed
    };
};

export default withRouter(connect(mapStateToProps)(AppRouter));
